import { inject, Injectable } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialogComponent, type ConfirmDialogData, type ConfirmDialogResult } from './confirm-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  private readonly dialog = inject(Dialog);

  async confirm(data: ConfirmDialogData): Promise<boolean> {
    const dialogRef = this.dialog.open<ConfirmDialogResult, ConfirmDialogData>(ConfirmDialogComponent, { data });
    const result = await firstValueFrom(dialogRef.closed);
    return result === true || (typeof result === 'object' && result !== null && result.confirmed === true);
  }
}
